import React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

export const NextULogo = (props: SvgProps) => {
  return (
    <Svg width={80} height={30} fill="none" {...props}>
      <Path
        d="M25.29 15.347h6.15c-.111-1.413-.866-2.767-2.997-2.767-1.665 0-2.856 1.236-3.152 2.767Zm-.021 2.035c.34 1.62 1.642 2.768 3.544 2.768 1.302 0 2.516-.592 3.197-1.532l2.035 1.695c-1.14 1.553-3.175 2.56-5.602 2.56-3.752 0-6.356-2.857-6.356-6.4 0-3.567 2.605-6.424 6.356-6.424 3.818 0 6.03 2.768 6.03 6.63 0 .252-.021.504-.021.71h-9.183v-.007Z"
        fill="#21334D"
      />
      <Path
        d="M37.486 22.866h-3.478l4.61-6.445-4.566-6.149h3.619l2.76 3.692 2.76-3.692h3.618l-4.573 6.149 4.617 6.445h-3.5l-2.922-3.707-2.945 3.707ZM12.386 22.866v-6.682c0-2.13.903-3.167 2.767-3.167 1.843 0 2.738 1.036 2.738 3.167v6.682h2.886v-7.318c0-3.204-2.205-5.276-5.624-5.276-3.433 0-5.653 2.072-5.653 5.276v7.318h2.886ZM48.081 6.149v12.476s-.31 4.24 5.424 4.24h1.117v-2.612h-1.428s-1.864.073-1.864-1.628l.007-5.765h3.285v-2.612h-3.27v-4.1H48.08Z"
        fill="#21334D"
      />
      <Path
        d="M69.614 10.272v6.682c0 2.13-.91 3.167-2.775 3.167-1.842 0-2.737-1.036-2.737-3.167v-6.682h-2.886v7.318c0 3.204 2.205 5.276 5.623 5.276 3.434 0 5.661-2.072 5.661-5.276v-7.318h-2.886ZM61.223 21.94h-4.995v.932h4.995v-.932Z"
        fill="#00ED6B"
      />
    </Svg>
  );
};

export default NextULogo;
